"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { DropdownMenu, DropdownMenuContent, DropdownMenuCheckboxItem, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
function FiltersContent() {
  const {
    terms: categories,
    loading: categoriesLoading
  } = useEcommerceTerms();
  const [selectedSizes, setSelectedSizes] = useState<string[]>([]);
  const [sortOrder, setSortOrder] = useState("relevancia");
  const sizes = ["XS", "S", "M", "L", "XL"];
  const sortOptions = [{
    value: "relevancia",
    label: "Relevancia"
  }, {
    value: "precio-asc",
    label: "Precio: menor a mayor"
  }, {
    value: "precio-desc",
    label: "Precio: mayor a menor"
  }, {
    value: "novedad",
    label: "Novedad"
  }];
  const handleSizeToggle = (size: string) => {
    setSelectedSizes(prev => prev.includes(size) ? prev.filter(s => s !== size) : [...prev, size]);
  };
  return <nav className="flex items-center gap-6 overflow-x-auto px-6 py-4">
      {}
      <div className="flex items-center gap-4 shrink-0">
        {categoriesLoading ? <>
            {[...Array(5)].map((_, i) => <div key={i} data-index={i} className="h-5 w-20 rounded bg-muted/30 animate-pulse" />)}
          </> : categories.map((category, i) => <Link key={category.id} data-index={i} to={category.link || "#"} className="relative text-sm font-medium text-foreground transition-all duration-[var(--duration-fast)] hover:text-accent after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-0 after:bg-accent after:transition-all after:duration-[var(--duration-medium)] hover:after:w-full">
              {category.name}
            </Link>)}
      </div>

      {}
      <div className="flex items-center gap-3 shrink-0">
        <Badge variant="outline" className="flex items-center gap-1.5 border-accent/30 text-accent">
          <span className="size-1.5 rounded-full bg-accent animate-pulse" />
          Nuevo
        </Badge>
        <Badge variant="outline" className="flex items-center gap-1.5 border-accent/30 text-accent">
          <span className="size-1.5 rounded-full bg-accent animate-pulse" />
          Bestseller
        </Badge>
      </div>

      {}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm" className="gap-1 shrink-0">
            Talla
            <ChevronDown className="size-4 transition-transform duration-[var(--duration-fast)]" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="glass-effect w-48" align="start">
          {sizes.map((size, i) => <DropdownMenuCheckboxItem key={size} data-index={i} checked={selectedSizes.includes(size)} onCheckedChange={() => handleSizeToggle(size)}>
              {size}
            </DropdownMenuCheckboxItem>)}
        </DropdownMenuContent>
      </DropdownMenu>

      {}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm" className="gap-1 shrink-0">
            Precio
            <ChevronDown className="size-4 transition-transform duration-[var(--duration-fast)]" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="glass-effect w-56" align="start">
          <div className="flex flex-col gap-3 p-2">
            <input type="number" placeholder="Mínimo (MXN)" className="h-9 rounded-md border border-border bg-background px-3 text-sm outline-none focus-visible:border-accent focus-visible:ring-2 focus-visible:ring-accent/20" />
            <input type="number" placeholder="Máximo (MXN)" className="h-9 rounded-md border border-border bg-background px-3 text-sm outline-none focus-visible:border-accent focus-visible:ring-2 focus-visible:ring-accent/20" />
          </div>
        </DropdownMenuContent>
      </DropdownMenu>

      {}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm" className="gap-1 shrink-0">
            Ordenar
            <ChevronDown className="size-4 transition-transform duration-[var(--duration-fast)]" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="glass-effect w-52" align="end">
          <DropdownMenuRadioGroup value={sortOrder} onValueChange={setSortOrder}>
            {sortOptions.map((option, i) => <DropdownMenuRadioItem key={option.value} data-index={i} value={option.value}>
                {option.label}
              </DropdownMenuRadioItem>)}
          </DropdownMenuRadioGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </nav>;
}
export default function Filtros() {
  return <section id="filtros" className="sticky top-0 z-40 bg-background/80 backdrop-blur-md border-b border-border/50 shadow-soft">
      <EcommerceTermsProvider taxonomy="product_cat" wp_term_query={{
      per_page: 6
    }} term_fields={["id", "name", "link"]}>
        <FiltersContent />
      </EcommerceTermsProvider>
    </section>;
}